// Diálogo compartilhado "Datas diferentes no texto e no campo".
// Mudança 100% visual — a lógica (comparação, textos, decisão de usar/manter)
// continua no componente que o invoca via callbacks `onUsarTexto` / `onManter`.
import React from "react";
import { AppModal, AppModalPrimaryButton, AppModalSecondaryButton } from "@/components/ui/AppModal";
import { fmtDiaBR } from "@/lib/dateFromText";

export default function DivergenciaDataDialog({ open, onClose, dataTexto, dataCampo, onUsarTexto, onManter, testId = "div-data-dialog" }) {
  if (!open || !dataTexto || !dataCampo) return null;
  return (
    <AppModal
      open={open}
      onOpenChange={(o) => !o && onClose?.()}
      title="Datas diferentes no texto e no campo"
      size="sm"
      testId={testId}
      footer={(
        <>
          <AppModalSecondaryButton onClick={onClose} data-testid={testId + "-cancelar"}>
            Cancelar
          </AppModalSecondaryButton>
          <AppModalSecondaryButton onClick={onManter} data-testid={testId + "-manter"}>
            Manter {fmtDiaBR(dataCampo)}
          </AppModalSecondaryButton>
          <AppModalPrimaryButton onClick={onUsarTexto} data-testid={testId + "-usar-texto"}>
            Usar {fmtDiaBR(dataTexto)}
          </AppModalPrimaryButton>
        </>
      )}
    >
      <p style={{ fontSize: 14, color: "#62717F", lineHeight: 1.5 }}>
        A data escrita no texto da atividade (<strong style={{ color: "#003E62" }}>{fmtDiaBR(dataTexto)}</strong>) é diferente da data agendada (<strong style={{ color: "#003E62" }}>{fmtDiaBR(dataCampo)}</strong>). Qual é a certa?
      </p>
    </AppModal>
  );
}
